import React, { useEffect, useRef } from "react";

export default function SearchModal({
  props,
  closeModal,
  setSearchValue
}) {
  const ref = useRef();

  useOnClickOutside(ref, () =>
    setTimeout(() => {
      closeModal(false);
    }, 1000)
  );

  function useOnClickOutside(ref, handler) {
    useEffect(() => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [ref, handler]);
  }

  const ListPage = (data) => {
    if (data.candidatName) {
      localStorage.setItem("profile", JSON.stringify(data));
      window.open(`/candidate/profile/${data._id}`);
      setTimeout(() => {
        closeModal(false);
        setSearchValue("");
      }, 1500);
    } else if (data.clientCompanyName) {
      if (data.jobStatus == "To-Do") {
        localStorage.setItem("profile", JSON.stringify(data));

        setTimeout(() => {
          window.open("/clientTodo/clientToDoProfile");
          closeModal(false);
          setSearchValue("");
        }, 500);
      }

      if (data.jobStatus == "Signed Contract") {
        localStorage.setItem("archive", JSON.stringify(data));

        setTimeout(() => {
          window.open("/clientContract/clientSigned");
          closeModal(false);
          setSearchValue("");
        }, 500);
      }

      if (data.jobStatus == "In-Progress") {
        localStorage.setItem("embauch", JSON.stringify(data));

        setTimeout(() => {
          window.open("/clientProgress/clientInProgressProfile");
          closeModal(false);
          setSearchValue("");
        }, 500);
      }

      if (data.jobStatus == "Archived") {
        localStorage.setItem("archive", JSON.stringify(data));

        setTimeout(() => {
          window.open("/archived/archivedClientSeeprofile");
          closeModal(false);
          setSearchValue("");
        }, 500);
      }
    }
  };

  return (
    <>
      <div
        className="tw-flex cursor-pointer"
        onClick={() => ListPage(props)}
        ref={ref}
      >
        <div className="tw-flex tw-space-x-2 tw-px-4 tw-justify-between tw-items-center tw-w-full tw-text-[#8F8F8F] hover:tw-bg-[#FFE6CA50]">
          <div className="imgManLogo tw-w-24" />
          <div className="tw-bg-[#F5F6F8] tw-rounded-full tw-w-1/4 tw-py-3 tw-flex tw-justify-center tw-items-center tw-text-sm tw-font-medium">
            <p>
              {props.candidatName
                ? props.candidatName.length > 16
                  ? props.candidatName.slice(0, 15) + "..."
                  : props.candidatName
                : props.clientCompanyName
                  ? props.clientCompanyName.length > 16
                    ? props.clientCompanyName.slice(0, 15) + "..."
                    : props.clientCompanyName
                  : "No Card!"}
            </p>
          </div>
          <div className="tw-bg-[#F5F6F8] tw-rounded-full tw-w-1/4 tw-py-3 tw-flex tw-justify-center tw-items-center tw-text-sm tw-font-medium">
            <p>
              {props.candidatActivitySector
                ? props.candidatActivitySector.length > 16
                  ? props.candidatActivitySector.slice(0, 15) + "..."
                  : props.candidatActivitySector
                : props.clientJob
                  ? props.clientJob.length > 16
                    ? props.clientJob.slice(0, 15)
                    : props.clientJob
                  : "No Job!"}
            </p>
          </div>
          <div className="tw-rounded-full tw-w-1/4 tw-py-3 tw-flex tw-justify-center tw-items-center tw-text-base tw-font-semibold">
            {props.candidatStatus == "To-Do" || props.candidatStatus === 'New' || props.jobStatus == "To-Do" ? (
              <button className="tw-text-sm tw-font-medium tw-bg-[#E4F4FF] tw-text-[#3F76E2] tw-w-full tw-py-3 tw-rounded-full">TO DO</button>
            ) : props.candidatStatus == "In-Progress" ||
              props.jobStatus == "In-Progress" || props.candidatStatus === "Hired" ? (
              <button className="tw-text-sm tw-font-medium tw-bg-[#F4E7FF] tw-text-[#A461D8] tw-w-full tw-py-3 tw-rounded-full">IN PROGRESS</button>
            ) : props.candidatStatus == "Archived" ||
              props.jobStatus == "Archived" || props.candidatStatus === "Fired" || props.candidatStatus === "Denied" || props.candidatStatus === "Finished" || props.candidatStatus === "Dead Lead" ? (
              <button className="tw-text-sm tw-font-medium tw-bg-[#FFE0E0] tw-text-[#FF0000] tw-w-full tw-py-3 tw-rounded-full tw-uppercase">{props.candidatStatus || props.jobStatus}</button>
            ) : props.jobStatus == "Signed Contract" ? (
              <button
                className="tw-text-sm tw-font-medium tw-bg-green-400 tw-text-white tw-w-full tw-py-3 tw-rounded-full"
              >
                SIGNED CONTRACT
              </button>
            ) : props.candidatStatus == "Pre-Selected" || props.candidatStatus === "Collecting Docs" ? (
              <button className="tw-text-sm tw-font-medium tw-bg-[#FFF7EE] tw-text-[#FE8700] tw-w-full tw-py-3 tw-rounded-full">PRE SELECTED</button>
            ) : props.candidatStatus == "No Answer" ? <button className="tw-text-sm tw-font-medium tw-bg-[#FFE0E0] tw-text-[#FF0000] tw-w-full tw-py-3 tw-rounded-full">NO ANSWER</button> :
              props.candidatStatus == "Contacted" ? <button className="tw-text-sm tw-font-medium tw-bg-[#F4E7FF] tw-text-[#A461D8] tw-w-full tw-py-3 tw-rounded-full">CONTACTED</button> :
                props.candidatStatus == "Interested" ? <button className="tw-text-sm tw-font-medium tw-bg-[#F4E7FF] tw-text-[#A461D8] tw-w-full tw-py-3 tw-rounded-full">INTERESTED</button> :
                  null}
          </div>
        </div>
      </div>
    </>
  );
}
